/**
 * Settings Feature Types
 *
 * The Settings page's tabs. The Security tab's sign-in methods and sessions
 * are @tonnie/account's, shared with Business Web.
 */

// ============================================================================
// TAB TYPES
// ============================================================================

/** Available settings tab identifiers */
export type SettingsTab = 'profile' | 'security' | 'preferences' | 'about';

/** All valid settings tabs */
export const SETTINGS_TABS: SettingsTab[] = ['profile', 'security', 'preferences', 'about'];

/** Default tab when none is specified in the URL */
export const DEFAULT_SETTINGS_TAB: SettingsTab = 'profile';

/** The Settings path; the tab is its `?tab=` (absent = the default tab). */
export const SETTINGS_PATH = '/settings';

/**
 * The Settings tab a query string names — the ONE reading of it. The page's
 * tabs and the sidebar both derive from the URL, so they cannot disagree.
 */
export function settingsTabFromSearch(search: string): SettingsTab {
  const tab = new URLSearchParams(search).get('tab');
  return tab && (SETTINGS_TABS as string[]).includes(tab)
    ? (tab as SettingsTab)
    : DEFAULT_SETTINGS_TAB;
}

/** The address of a Settings tab (the default tab is the bare path). */
export function settingsTabHref(tab: SettingsTab): string {
  return tab === DEFAULT_SETTINGS_TAB ? SETTINGS_PATH : `${SETTINGS_PATH}?tab=${tab}`;
}
